import { Component, Input, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { ODReport } from '../../../redux/models/dashboard/report';
import { diveTrigger } from '../../../redux/models/dashboard/animations';

@Component({
  standalone: false,
  selector: 'app-dashboard-origins',
  templateUrl: './dashboard-origins.component.html',
  styleUrls: ['./dashboard-origins.component.scss'],
  animations: [diveTrigger]
})
export class DashboardOriginsComponent implements OnInit {
  @Input() items: ODReport[];
  @Input() recordTitle: string;
  @Input() allRecordsTitle: string;
  valuesScale = 0;
  diveState = 'out';
  private scalingStart: number;
  private readonly scalingDuration = 800;
  private readonly pointFiveConst = 0.5;

  constructor(private readonly zone: NgZone, private readonly changeDetector: ChangeDetectorRef) {}
  ngOnInit() {
    // wait for outer animation
    setTimeout(() => {
      this.diveState = 'in';
      this.startValueScaling();
    }, 200);
  }

  startValueScaling() {
    if (this.scalingStart) {
      return;
    }
    this.zone.runOutsideAngular(() => requestAnimationFrame(this.animate.bind(this)));
  }

  getScaledOriginValue(value: number): number {
    return Math.round(value * this.valuesScale);
  }

  compareValue(value: number) {
    return value < this.pointFiveConst ? '&lt;1' : this.getScaledOriginValue(value);
  }

  private animate(timestamp: number) {
    this.scalingStart = this.scalingStart || timestamp;
    this.valuesScale = (timestamp - this.scalingStart) / this.scalingDuration;
    if (this.valuesScale >= 1) {
      this.valuesScale = 1;
      this.scalingStart = null;
    }
    Promise.resolve().then(() => this.changeDetector.detectChanges());
    if (this.valuesScale < 1) {
      requestAnimationFrame(this.animate.bind(this));
    }
  }
}
function retrun /*eslint-disable-line @typescript-eslint/no-unused-vars*/() {
  throw new Error('Function not implemented.');
}
